import * as actions from '../ActionType/UserActionType';
import Users from '../Reducers/ResponseHelper'
const dispatchAction: any = (dispatch: any, actionType: any, data: any, error: string, message: string) => {
    dispatch({ type: actionType, payload: data, message: message });
};

class UserSevicesApi {
    GetToken = (instance: any, request: any) => async (dispatch: any) => {
        try {
            const accessToken: any = await Users.GETACCESSTOKEN(instance, request)
                .then((result => {
                    if (result) {
                        dispatchAction(dispatch, actions.TOKEN, result)
                    } else {
                        dispatchAction(dispatch, actions.TOKEN, result, [], 'Invalid Token !')
                    }
                })).catch((error => {
                    console.log(error);
                    instance.logoutRedirect();
                    localStorage.clear();
                })
                );
        } catch (error) {
            console.log(error, 'AccessToken')
        }
    }
    UserListData = (user: any, accessToken: string, enqueueSnackbar: any) => async (dispatch: any) => {
        try {
            const listUser = await Users.USER_LIST(user, accessToken);
            if (listUser?.length) {
                dispatchAction(dispatch, actions.USER_LIST, listUser, 'Invalid user list data !')
            } else {
                //enqueueSnackbar(listUser?.errors?.message, { variant: 'error' })
                dispatchAction(dispatch, actions.USER_LIST, [], 'Invalid user list data !')
            }

        } catch (error) {
            console.log('list User', error);
        }
    }
    InpersonateUserData = (accessToken: string, enqueueSnackbar: any) => async (dispatch: any) => {
        try {
            const listUser = await Users.INPERSONATE_LIST(accessToken);
            if (listUser?.length) {
                dispatchAction(dispatch, actions.INPERSONATE_USER_LIST, listUser, 'Invalid user list data !')
            } else {
                //enqueueSnackbar(listUser?.errors?.message, { variant: 'error' })
                dispatchAction(dispatch, actions.INPERSONATE_USER_LIST, [], 'Invalid user list data !')
            }

        } catch (error) {
            console.log('list User', error);
        }
    }
    allGetUserList = (accessToken: string) => async (dispatch: any) => {
        try {
            const listAllUser = await Users.ALL_GET_USER(accessToken);
            if (listAllUser) {
                dispatchAction(dispatch, actions.GET_ALL_USER_LIST, listAllUser)
            } else {
                dispatchAction(dispatch, actions.GET_ALL_USER_LIST, listAllUser, [], 'Invalid all get user list  !')
            }
        } catch (error) {
            console.log('get all list User', error);
        }
    }
    createUser = (userData: any, accessToken: string) => async (dispatch: any) => {
        try {
            const userCreate = await Users.CREATE_USER(userData, accessToken);
            if (userCreate) {
                dispatchAction(dispatch, actions.USER_CREATE, userCreate)
            } else {
                dispatchAction(dispatch, actions.USER_CREATE, userCreate, [], 'Invalid create user !')
            }
        } catch (error) {
            console.log('list User', error);
        }
    }
    userUpdate = (userid: any, userData: any, accessToken: string, enqueueSnackbar: any) => async (dispatch: any) => {
        try {
            const updateUser = await Users.UPDATE_USER(userid, userData, accessToken);
            if (updateUser) {
                updateUser?.error ?
                    enqueueSnackbar(updateUser?.error?.message, { variant: 'error' }) :
                    dispatchAction(dispatch, actions.USER_UPDATE, updateUser)
                        (enqueueSnackbar('Success!', { variant: 'success' }))
            } else {
                dispatchAction(dispatch, actions.USER_UPDATE, updateUser, [], 'Invalid update user !')
            }
        } catch (error) {
            console.log('list User', error);
        }
    }
    deleteUser = (userId: any, accessToken: string, enqueueSnackbar: any) => async (dispatch: any) => {
        try {
            const delete_User = await Users.DELETE_USER(userId, accessToken);
            if (delete_User) {
                delete_User?.error ?
                    enqueueSnackbar(delete_User?.error?.message, { variant: 'error' }) :
                    dispatchAction(dispatch, actions.USER_DELETE, delete_User)
                        (enqueueSnackbar('Success!', { variant: 'success' }))
            } else {
                dispatchAction(dispatch, actions.USER_DELETE, delete_User, [], 'Invalid delete user !')
            }
        } catch (error) {
            console.log('list User', error);
        }
    }
    userDetails = (userId: any, accessToken: string, enqueueSnackbar: any) => async (dispatch: any) => {
        try {
            const detail_User = await Users.USER_DETAILS(userId, accessToken);
            if (detail_User) {
                detail_User?.error ?
                    enqueueSnackbar(detail_User?.error?.message, { variant: 'error' }) :
                    dispatchAction(dispatch, actions.USER_DETAIL, detail_User)
                        (enqueueSnackbar('Success!', { variant: 'success' }))
            } else {
                dispatchAction(dispatch, actions.USER_DETAIL, detail_User, [], 'Invalid user information !')
            }
        } catch (error) {
            console.log('list User', error);
        }
    }
    usersCallApiToken = (param: any, accessToken: string, instance: any, enqueueSnackbar: any) => async (dispatch: any) => {
        try {
            const alll_User = await Users.ALL_USERS(param, accessToken, instance, enqueueSnackbar);
            if (alll_User?.role) {
                dispatchAction(dispatch, actions.USER_ALL, alll_User)
            } else {
                enqueueSnackbar(alll_User.error?.message, { variant: 'error' })
                instance.logoutRedirect();
                localStorage.clear();
                dispatchAction(dispatch, actions.USER_ALL, alll_User, [], 'Invalid user authentication !')
            }
        } catch (error) {
            console.log('list User', error);
        }
    }
    getRole = (userId: string, accessToken: string, enqueueSnackbar: any) => async (dispatch: any) => {
        try {
            const get_Role = await Users.GET_ROLE(userId, accessToken);
            if (get_Role) {
                get_Role?.error ?
                    enqueueSnackbar(get_Role?.error?.message, { variant: 'error' }) :
                    dispatchAction(dispatch, actions.ROLE, get_Role)
                        (enqueueSnackbar('Success!', { variant: 'success' }))
            } else {
                dispatchAction(dispatch, actions.ROLE, get_Role, [], 'Invalid get roles !')
            }
        } catch (error) {
            console.log('list User', error);
        }
    }
}
export default new UserSevicesApi();
